export default "__VITE_ASSET__Dp9vCg7z__"